import Vue from 'vue'

export default function($store, $sfmcFolder) {
    return new Vue({
        data: function() {
            return {
                foldersAvailable: [],   
                folders: [
                    {label: 'Data Extensions', value: 'Data Extensions', ent: false, synchronized: false, canCreateDE: true},
                    {label: 'Shared Data Extensions', value: 'Shared Items>Shared Data Extensions', ent: true, synchronized: false, canCreateDE: false},
                    {label: 'Salesforce Data Extensions', value: 'Salesforce Data Extensions', ent: false, synchronized: false, canCreateDE: false},
                    {label: 'Synchronized Data Extensions', value: 'Synchronized Data Extensions', ent: true, synchronized: true, canCreateDE: false},
                    {label: 'Shared Salesforce Data Extensions', value: 'Shared Items>Shared Salesforce Data Extensions', ent: true, synchronized: false, canCreateDE: false}
                ]
            };
        },
        created: function() {
            if (this.bu.id) {
                this.makeFoldersAvailable();
            }
        },
        computed: {
            bu: function() {
                return $store.getters.bu;
            }
        },
        watch: {
            bu: function() {
                if (this.bu.id) {
                    this.makeFoldersAvailable();
                }
            }
        },
        methods: {
            makeFoldersAvailable: function() {
                var promises = [];
                this.foldersAvailable.splice(0, this.foldersAvailable.length);
                this.folders.forEach((folder) => {
                    promises.push($sfmcFolder.apiCall(
                        "retrieve_from_path",
                        {
                            path: folder.value,
                            get_properties: [
                                "Name",
                                "ID",
                                "ContentType"
                            ],
                            single_result: false
                        },
                        true
                    ))
                });
                return Promise.all(promises).then(
                    (responses) => {
                        this.foldersAvailable.splice(0, this.foldersAvailable.length);
                        responses.forEach((response, responseIdx) => {
                            if (response.data && response.data.length) {
                                response.data.forEach((folderData) => {
                                    var folderStaging = JSON.parse(JSON.stringify(this.folders[responseIdx]));
                                    folderStaging.id = folderData.ID;
                                    if (response.data.length > 1) {
                                        folderStaging.label += ` (${folderData.ID})`
                                    }
                                    this.foldersAvailable.push(folderStaging);
                                });
                            }
                        });
                        return Promise.resolve();
                    }
                );
            },
            getFoldersAvailable: function() {
                if (this.foldersAvailable.length) {
                    return Promise.resolve(JSON.parse(JSON.stringify(this.foldersAvailable)));
                } else {
                    return this.makeFoldersAvailable().then(
                        () => Promise.resolve(JSON.parse(JSON.stringify(this.foldersAvailable)))
                    );
                }
            },
            isEnt: function(arg) {
                var p;
                //
                // This is a category ID
                if (String(arg).match(/^[0-9]+$/)) {
                    p = $sfmcFolder.apiCall(
                        'retrieve_path_from_id',
                        {
                            id: arg
                        }
                    ).then(
                        (respsonse) => Promise.resolve(respsonse.data)
                    );
                } else {
                    p = Promise.resolve(arg);
                }
                return p.then(
                    (path) => {
                        var isEnt = false;
                        path = path.replace(/\//g, '>').toLowerCase();
                        this.folders.forEach((folder) => {
                            if (
                                folder.ent &&
                                (path.substr(0, folder.value.length) == folder.value.toLowerCase())
                            ) {
                                isEnt = true;
                            }
                        });
                        return Promise.resolve(isEnt);
                    }
                );
            },
            entPrefix: function(value) {
                var folder = this.folders.find((folder) => (folder.value == value));
                if ($store.getters.bu.isChild && folder.ent) {
                    return 'ent.';
                } else {
                    return '';
                }
            }
        }
    });
    /*
    return {
        folders: [
            {label: 'Data Extensions', value: 'Data Extensions', ent: false, synchronized: false},
            {label: 'Shared Data Extensions', value: 'Shared Items>Shared Data Extensions', ent: true, synchronized: false},
            {label: 'Salesforce Data Extensions', value: 'Salesforce Data Extensions', ent: false, synchronized: false},
            {label: 'Synchronized Data Extensions', value: 'Synchronized Data Extensions', ent: true, synchronized: false},
            {label: 'Shared Salesforce Data Extensions', value: 'Shared Items>Shared Salesforce Data Extensions', ent: true, synchronized: false}
        ],
        entPrefix: function(value) {
            var folder = this.folders.find((folder) => (folder.value == value));
            if ($store.getters.bu.isChild && folder.ent) {
                return 'ent.';
            } else {
                return '';
            }
        }
    };
    */
}